import React, { createContext, useContext, useState, ReactNode } from 'react';
import { autenticarUsuarioCliente, buscarBaseURL } from '../modules/login/apis/serviceLogin';
import { Toast } from '../themes/components/Toast';
//importing context
import { useLocalStorage } from './LocalStorage';
import { io } from 'socket.io-client';

const AuthContext = createContext({} as PropsContextProvider);

interface User {
    codUser: string | null,
    codPriceTable: string | null,
    mail: string | null,
    nameInfo: string | null,
    username: string | null,
    role: string | null,
    token: string | null
}

type PropChildren = {
    children: ReactNode;
}

type PropsContextProvider = {
    user: User | null,
    setUser: React.Dispatch<React.SetStateAction<User | null>>,
    realizarLogin: (username: string, password: string, history: any, location: any) => Promise<void> | Promise<{ result: string; }> | Promise<unknown> | void,
    loading: boolean,
    setLoading: React.Dispatch<React.SetStateAction<boolean>>,
    logout: (history: any) => void,
    socket: any,
    setSocket: any
}

export default function AuthProvider({ children }: PropChildren) {
    const { saveInSessionStorage, clearSessionStorage, saveInLocalStorage } = useLocalStorage();
    const [user, setUser] = useState<User | null>({
        codUser: null,
        codPriceTable: null,
        mail: null,
        nameInfo: null,
        username: null,
        role: null,
        token: null
    });
    const [loading, setLoading] = useState<boolean>(false);
    const [socket, setSocket] = useState<any>(false);

    function realizarLogin(username: string, password: string, history: any, location: any) {
        if (username === "" || password === "") {
            Toast("error", "Usuário e Senha são obrigatórios.");
        } else {
            setLoading(true);
            validate(username, password, history, location);
        }
    }

    function logout(history: any) {
        clearSessionStorage();
        history.push(`${process.env.PUBLIC_URL}/login`);
    }

    async function validate(username: string, password: string, history: any, location: any) {
        await buscarBaseURL("GA.ADATEC-UNI")
            .then(res => {
                //Salvando na base local a base_url vinda da API da ADA para o código do cliente informado.
                saveInLocalStorage("base_url", res.base_url);
                //Realizando autenticação chamando o backend do cliente.
                async function autentication() {
                    await autenticarUsuarioCliente(username, password)
                        .then(result => {
                            //console.log("Configurando url do socket io - " + res.base_url);
                            setSocket(io(res.base_url))
                            setUser({
                                codUser: result.codRep,
                                codPriceTable: result.codTpr,
                                mail: result.intNet,
                                nameInfo: result.nomRep,
                                username: result.nomUsu,
                                role: result.setUsu,
                                token: result.token
                            });
                            setLoading(false);
                            //Salvando na sessão algumas informações para aparecerem na tela
                            let name = result.nomRep.split(" ")[0] + " " + result.nomRep.split(" ")[1];
                            saveInSessionStorage("user_name", name);
                            saveInSessionStorage("nomRep", result.nomRep);
                            saveInSessionStorage("userlogin", result.nomUsu);
                            saveInSessionStorage("user_empresa", result.codEmp);
                            saveInSessionStorage("user_filial", result.codFil);
                            saveInSessionStorage("user_codrep", result.codRep);
                            saveInSessionStorage("user_codtab", result.codTpr);
                            saveInSessionStorage("logid", result.token);
                            saveInSessionStorage("intNet", result.intNet);
                            saveInSessionStorage("cotDol", result.cotDol);
                            //console.log("result.pedDol");
                            //console.log(result.pedDol);
                            if (result.cotDol === "0.0") {
                                saveInSessionStorage("pedDol", "N");
                                if (result.pedDol === "S") {
                                    Toast("error", `Pedido em dólar ativado, porém cotação do dólar com valor 0.0`);
                                }
                            } else {
                                saveInSessionStorage("pedDol", result.pedDol);
                            }
                            //Verificando se a pessoa foi mandada pra tela de login de alguma rota,
                            //caso tenha sido a pessoa será encaminhada para a rota que estava no location
                            if (location.state !== undefined && location.state.from !== undefined) {

                                history.push({
                                    pathname: process.env.PUBLIC_URL + location.state.from.replace("/clientes/ga/pedidos-force", ""),
                                    state: { from: '/login' }
                                });
                                Toast("success", `Bem vindo(a) de volta ${name}`);
                            } else {
                                history.push({
                                    pathname: `${process.env.PUBLIC_URL}/inicio`,
                                    state: { from: '/login' }
                                });
                                Toast("success", `Seja bem vindo(a) ${name}`);
                            }

                        })
                        .catch(res => {
                            console.log("error");
                            console.log(res);
                            setUser(null);
                            setLoading(false);

                            //Definindo mensagens mais amigáveis para erros comuns de retorno do backend
                            if (res.error.message !== undefined) {
                                switch (res.error.message) {
                                    case "Usuário não tem cadastro de representante!":
                                        Toast("error", "Usuário não encontrado.");
                                        break;
                                    case "UsuÃ¡rio ou senha incorretos":
                                        Toast("error", "Senha inválida.");
                                        break;
                                    case "Network Error":
                                        Toast("error", "Falha na conexão, verifique sua internet e tente novamente.");
                                        break;
                                    default:
                                        Toast("error", "Falha ao realizar login.");
                                        break;
                                }
                            } else {
                                Toast("error", "Falha ao realizar login.");
                            }
                        })
                }
                autentication();
            })
            .catch(function () {
                Toast("error", "Acesso desabilitado - Contactar o suporte da ADA");
            })
    }

    return (
        <AuthContext.Provider
            value={{
                user,
                setUser,
                realizarLogin,
                loading,
                setLoading,
                logout,
                socket,
                setSocket
            }}>
            {children}
        </AuthContext.Provider>
    )
}

//A intenção de usar o hook para o contexto é facilitar a importação nos componentes,
//Somente o que estiver nesse hook poderá ser importado via hook, obviamente!
export function useAuth() {
    const context = useContext(AuthContext);
    if (!context) throw new Error("useAuth deve ser usado dentro de um AuthProvider");
    const { user, setUser, realizarLogin, loading, setLoading, logout, socket, setSocket } = context;
    return ({ user, setUser, realizarLogin, loading, setLoading, logout, socket, setSocket});
}
